import { Avatar, Box } from '@mui/material';

interface GradientAvatarProps {
  gradient: string;
  badge: string;
  badgeColor: string;
}

export const GradientAvatar = ({ gradient, badge, badgeColor }: GradientAvatarProps) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      <Avatar
        sx={{
          width: 48,
          height: 48,
          background: gradient,
          border: '2px solid',
          borderColor: 'divider',
        }}
      />
      {badge && (
        <Box
          sx={{
            position: 'absolute',
            bottom: -2,
            right: -2,
            width: 20,
            height: 20,
            borderRadius: '50%',
            bgcolor: badgeColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid',
            borderColor: 'background.paper',
            fontSize: '0.75rem',
          }}
        >
          {badge}
        </Box>
      )}
    </Box>
  );
};
